import React, { useEffect, useState } from "react";
import { set } from "lodash";
import Box from "@amzn/meridian/box";
import Tab, { TabGroup } from "@amzn/meridian/tab";

import { SpaceGrid } from "../commons/SpaceGrid";
import { IAppealProps } from "../approach-table/ApproachComponent";
import { summaryMapping } from "../commons/spaceTableDefinition";
import { SpaceComponent } from "../commons/SpaceComponent";

interface CostApproachData {
    spaceComputationData: {
        [key: string]: {
            spaceType: string;
        };
    };
}

export const CostApproachComponent: React.FC<IAppealProps> = ({
    data,
    handleUpdateData,
    isEditing,
}) => {
    const [currentTab, setCurrentTab] = useState<string>("");

    const handleInputChange = (field: string, value: any) => {
        set(data, field, value);
        handleUpdateData(data);
    };

    const costApproachData: CostApproachData =
        data.appealDetails.appealApproachCalculationData.cost.costApproachData;

    useEffect(() => {
        if (currentTab === "" && Object.keys(costApproachData.spaceComputationData).length > 0) {
            setCurrentTab(Object.keys(costApproachData.spaceComputationData)[0]);
        }
    }, [costApproachData.spaceComputationData]);

    const renderTabContent = () => {
        const commonProps = {
            data,
            spaceId: currentTab,
            isEditing,
            handleInputChange,
            viewType: "COST",
        };

        switch (currentTab) {
            case "Features":
                return <SpaceComponent {...commonProps} spaceType="CostFeature" />;
            case "Site improvements":
                return <SpaceComponent {...commonProps} spaceType="CostSiteImprovement" />;
            default:
                return <SpaceComponent {...commonProps} spaceType="CostSpace" />;
        }
    };

    return (
        <>
            <Box>
                <SpaceGrid
                    title="Cost approach calculation"
                    mapping={summaryMapping(data)}
                    handleInputChange={handleInputChange}
                    isEditing={isEditing}
                    backgroundColor="subdued"
                    spacingInset="500"
                    data={data}
                />
            </Box>
            <TabGroup value={currentTab} onChange={setCurrentTab} fill="line">
                {Object.entries(costApproachData.spaceComputationData)
                    .reverse()
                    .map(([key, value]) => (
                        <Tab key={key} id={key} value={key}>
                            {value.spaceType}
                        </Tab>
                    ))}
                <Tab id="Features" value="Features">
                    Features
                </Tab>
                <Tab id="Site improvements" value="Site improvements">
                    Site improvements
                </Tab>
            </TabGroup>
            {renderTabContent()}
        </>
    );
};
